import { useTranslation } from 'react-i18next';
import { DetailRows, withStyles } from 'vopay';
import { BodyText, CollapsibleCard, Title } from 'UI';
import useTransferDetailRows, { TransferBankAccount, TransferDetails } from '../useTransferDetailRows';
import styles from './TransferReview.module.scss';

const cn = withStyles(styles);

type TransferReviewProps = {
  title: string;
  transfer: TransferDetails;
  bankAccount: TransferBankAccount;
};

export default function TransferReview({ title, transfer, bankAccount }: TransferReviewProps) {
  const { t } = useTranslation('translations', { keyPrefix: 'Accounts.AutoBalanceTransfer.TransferReview' });
  const { transferDetailRows, bankAccountDetailRows } = useTransferDetailRows();

  const sections = [
    {
      id: 'transfer-details',
      heading: t('transferDetails', { defaultValue: 'Transfer Details' }),
      rows: transferDetailRows(transfer),
    },
    {
      id: 'bank-account-details',
      heading: t('bankAccountDetails', { defaultValue: 'Bank Account Details' }),
      rows: bankAccountDetailRows(bankAccount),
    },
  ];

  return (
    <>
      <div className={cn('header')}>
        <Title>{title}</Title>

        <BodyText className={cn('description')}>
          {t('description', { defaultValue: 'Please review the details that you have provided.' })}
        </BodyText>
      </div>

      {sections.map(({ id, heading, rows }) => (
        <CollapsibleCard key={id} defaultOpen data-testid={`auto-balance-transfer-review-${id}`}>
          <CollapsibleCard.Trigger indicator="chevron" className={cn('cardSection')}>
            {heading}
          </CollapsibleCard.Trigger>

          <CollapsibleCard.Content className={cn('cardSection')}>
            <DetailRows details={rows} />
          </CollapsibleCard.Content>
        </CollapsibleCard>
      ))}
    </>
  );
}
